<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>Promotions</h1>
      <ol class="breadcrumb">
        <li>
          <a @click="$router.push({ name: 'dashboard' })">
            <i class="fa fa-dashboard"></i> Dashboard
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'promo-index' })">
            <i class="fa fa-gift"></i> Promotions
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'promo-code-index' })">
            <i class="fa fa-ticket"></i> Code
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <h3>Filter Promo Code</h3>
          <div class="box-tools pull-right">
            <button type="button"
              class="btn btn-box-tool"
              data-widget="collapse">
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="box-body" style="overflow: hidden;">
          <div class="form-group">
            <label for="name">
              Promo Code
            </label>

            <input type="text"
              class="form-control"
              id="code"
              placeholder="Search by promo code here"
              v-model="params.code"
              @keyup="onInput">
          </div>
        </div>
      </div>

      <div class="box">
        <div class="box-header">
          <div class="box-title">
            <h3>Promo Codes</h3>
          </div>
          <a class="btn btn-success pull-right" @click.prevent="add">Create New</a>
        </div>

        <div class="box-body">
          <div class="box-body table-responsive">
            <table class="table table-hover">
              <transition name="fade" mode="out-in">
                <tbody v-if="isLoading" key="loading">
                  <tr>
                    <td colspan="14">
                      <strong>Loading</strong>
                    </td>
                  </tr>
                </tbody>

                <tbody v-else-if="!isLoading && items.length < 1" key="empty">
                  <tr>
                    <td colspan="14">
                      <strong>Result not found</strong>
                    </td>
                  </tr>
                </tbody>

                <tbody v-else key="data">
                  <tr>
                    <th class="text-center">Promo Code</th>
                    <th style="min-width: 21rem">Promo Payment</th>
                    <th class="text-center" style="min-width: 10rem">Status</th>
                    <th class="text-center" style="min-width: 10rem">Start Date</th>
                    <th class="text-center" style="min-width: 10rem">End Date</th>
                    <th class="text-center" style="min-width: 14rem">Time Range</th>
                    <th class="text-center" style="min-width: 10rem">Applicable To</th>
                    <th class="text-center" style="min-width: 8rem">Type</th>
                    <th class="text-center" style="min-width: 10rem">Nominal</th>
                    <th style="min-width: 10rem">Min. Amount</th>
                    <th style="min-width: 15rem">Max. Amount</th>
                    <th style="min-width: 10rem">Minimum Pay</th>
                    <th class="text-center">Quota</th>
                    <th class="text-center">Daily Quota</th>
                    <th class="text-center">Recurring Type</th>
                    <th class="text-center" style="min-width: 12rem">Recurring Value</th>
                    <th class="text-center" style="min-width: 12rem">Locked Domains</th>
                    <th class="text-center" style="min-width: 14rem">Action</th>
                  </tr>

                  <tr v-for="(item, index) in items" :key="index">
                    <td>
                      <a
                        class="label label-block text-uppercase"
                        @click.prevent="edit(item.id)"
                        :class="{
                          'label-info': item.detail.type === 'percentage',
                          'label-success': item.detail.type === 'amount',
                        }"
                      >{{ item.code }}</a>
                    </td>
                    <td>
                      <template
                        v-if="item.promo_config_name"
                      >{{ capitalizeFirstLetter(item.promo_config_name) }}</template>
                      <template v-else>-</template>
                    </td>
                    <td class="text-center">
                      <strong
                        :class="{
                        'text-success': item.is_enable === 1,
                        'text-muted': item.is_enable === 0
                      }"
                      >
                        <i class="fa fa-check-square-o" v-if="item.is_enable === 1"></i>
                        <i class="fa fa-square-o" v-else></i>
                        {{ parseStatus(item.is_enable) }}
                      </strong>
                      <!-- <a class="btn btn-block btn-default btn-xs"
                        @click.prevent="toggleStatus(item)">
                        <template v-if="item.is_enable === 1">Deactivate</template>
                        <template v-else>Activate</template>
                      </a>-->
                    </td>
                    <td
                      class="text-center"
                      :class="{
                        'text-primary strong': item.is_date_active,
                        'text-muted': !item.is_date_active,
                      }"
                    >{{ item.start_date | simpleDate }}</td>
                    <td
                      class="text-center"
                      :class="{
                        'text-primary strong': item.is_date_active,
                        'text-muted': !item.is_date_active,
                      }"
                    >{{ item.end_date | simpleDate }}</td>
                    <td
                      class="text-center"
                      :class="{
                        'text-primary strong': item.is_date_active,
                        'text-muted': !item.is_date_active,
                      }"
                    >{{ item.start_time }} - {{ item.end_time }}</td>
                    <td class="text-center">
                      <template v-for="media in item.detail.medias">
                        <span class="label" :class="media">
                          <i class="fa fa-fw" :class="parseMedia(media)"></i>
                        </span>
                      </template>
                    </td>
                    <td class="text-center">{{ capitalizeFirstLetter(item.detail.type) }}</td>
                    <td
                      class="text-center"
                    >{{ parseNominal(item.detail.nominal, item.detail.type) }}</td>
                    <td>{{ item.detail.minimum_pay_amount | digitGrouping }}</td>
                    <td>{{ item.detail.maximum_amount | digitGrouping }}</td>
                    <td>{{ item.detail.minimum_payment | digitGrouping }}</td>
                    <td class="text-center">{{ item.quota }}</td>
                    <td class="text-center">{{ item.daily_quota }}</td>
                    <td
                      class="text-center"
                      style="text-transform: capitalize;"
                    >{{ item.detail.recurring_type }}</td>
                    <td>{{ renderRecurringValue(item.detail.recurring_type, item.detail.recurring_value) }}</td>
                    <td>{{ checkLockedDomain(item.detail.is_locked_domain, item.detail.locked_domains) }}</td>
                    <td class="text-center">
                      <a
                        class="btn btn-info btn-xs"
                        style="min-width: 6rem"
                        @click.prevent="view(item.id)"
                      >View</a>
                      <a
                        class="btn btn-default btn-xs"
                        style="min-width: 6rem"
                        @click.prevent="edit(item.id)"
                      >Edit</a>
                      <!-- <a class="btn btn-danger btn-xs"
                        style="min-width: 6rem"
                        @click.prevent="remove(item)">
                        Delete
                      </a>-->
                    </td>
                  </tr>
                </tbody>
              </transition>
            </table>
          </div>
        </div>

        <div class="box-footer">
          <Pagination :pagination="pagination" @goto-page="changePage"/>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import numeral from 'numeral';
import moment from 'moment';
import Common from '@/mixins/Common';
import Pagination from '@/components/modules/common/Pagination';

export default {
  name: 'PromoCodeIndex',

  mixins: [Common],

  components: {
    Pagination,
  },

  data() {
    return {
      isLoading: true,
      items: [],
      pagination: {},
      days: {
        1: 'Mon',
        2: 'Tue',
        3: 'Wed',
        4: 'Thu',
        5: 'Fri',
        6: 'Sat',
        7: 'Sun',
      },

      params: {
        code: null,
        page: 1,
      },
    };
  },

  filters: {
    digitGrouping(string) {
      if (!string) return 'IDR 0';
      return `IDR ${numeral(string).format('0,0')}`;
    },

    simpleDate(string) {
      if (!string) return '';
      return moment(string).format('YYYY-MM-DD');
    },
  },

  methods: {
    onInput: debounce(function debouncedInput() {
      this.fetch();
    }, 500),

    fetch(page) {
      const pageQuery = this.$route.query.page;
      this.params.page = page || pageQuery;

      this.axios.get('/promo-code', { params: this.params })
        .then((response) => {
          const { data, meta } = response.data;

          if (!data && (meta.pagination.current_page > meta.pagination.total_pages)) {
            this.items = [];
            this.pagination = {};
            return;
          }

          this.items = data;

          this.items.forEach((item) => {
            item.detail.medias = item.detail.media.split(',');
          });

          this.pagination = meta.pagination;
          this.isLoading = false;
        })
        .catch(() => {
          this.$swal({
            title: 'Fetch Failed',
            text: 'Failed to fetch promo codes data',
            type: 'warning',
            timer: 5000,
          });
        });

      if (page) {
        window.history.pushState(`Promo codes page: ${page}`, null, `/promo/code?page=${page}`);
      }
    },

    changePage(page) {
      this.fetch(page);
    },

    add() {
      this.$router.push({ name: 'promo-code-create' });
    },

    edit(id) {
      this.$router.push({
        name: 'promo-code-edit',
        params: { id },
      });
    },

    view(id) {
      this.$router.push({
        name: 'promo-code-view',
        params: { id },
      });
    },

    toggleStatus(item) {
      const params = (item.is_enabled === 1) ? `deactivate/${item.id}` : `activate/${item.id}`;

      this.axios.patch(`/promo-code/${params}`)
        .then(() => {
          this.fetch();
        });
    },

    parseMedia(media) {
      if (!media) return '';

      if (media === 'web') {
        return 'fa-desktop';
      }

      if (media === 'ios') {
        return 'fa-apple';
      }

      return 'fa-android';
    },

    parseStatus(status) {
      if (status === 1) return 'Enabled';
      return 'Disabled';
    },

    parseNominal(string, type) {
      if (!string && !type) return '';
      if (type === 'percentage') {
        return `${string}%`;
      }
      return `IDR ${numeral(string).format('0,0')}`;
    },

    renderRecurringValue(type, value) {
      let recurringValue = '';

      if (type === 'day') {
        const days = value.split(',');

        days.forEach((day, index) => {
          recurringValue += this.days[parseInt(day, 10)];

          if (index + 1 !== days.length) {
            recurringValue += ',';
          }
        });
      }

      if (type === 'date') {
        recurringValue = value;
      }

      return recurringValue.replace(/,/g, ', ');
    },

    checkLockedDomain(status, string) {
      if (status === 0) {
        return 'None';
      }

      return string;
    },
  },

  created() {
    this.fetch();
  },
};
</script>

<style lang="scss" scoped>
.label {
  &.label-block {
    display: block;
    padding: 0.5rem;
  }

  &.web {
    background-color: #1976d2;
    margin: 0 0.125rem;
  }

  &.ios {
    background-color: #e91e63;
    margin: 0 0.125rem;
  }

  &.android {
    background-color: #4caf50;
    margin: 0 0.125rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/promo/code/Index.vue